import React from 'react';
import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  SActionBtn,
  SBack,
  SLowcodeList, SMessage,
  STableActions,
} from 'shj-components'
import config from './config.ts';
import {Button, message, TreeSelect, Upload} from "antd";
import {
  clueInfoList,
  getCustomerSource,
  getEnum,
  clueInfoDispatchClueAgain
} from '@/services/customerServices'
import {filterSearchData} from "@/utils/common.ts";

export default function PriceManage() {
  const history = useNavigate();
  const [sourceChannel, setSourceChannel] = useState([])
  const listRef = useRef<any>();

  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values;
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        const query_ = filterSearchData(query, ['createdTime'], ['StartWith', 'EndWith'])
        clueInfoList(current, pageSize, query_).then((resp: any) => {
          resolve(resp)
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 右侧表格事件：
  const onAdd = () => {
    history('/main/customerManage/clueList/clueImport')
  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  const onEdit = (record) => {
    clueInfoDispatchClueAgain(record.id).then((resp: any) => {
      message.success(resp.message || '操作成功')
      reloadFn()
    })
  }

  const getStatusOptions = () => {
    return new Promise(async resolve => {
      const channel = await getCustomerSource()
      setSourceChannel(channel)
      const clueStatusList = await getEnum('com.shj.saas.plus.clue.enums.ClueStatusEnum')
      resolve({
        clueStatusList
      })
    })
  }
  const exportHandler = () => {
    // const filterData = cloneDeep(getFieldsValuesFn())
    // const searchValues = getSearchParams(filterData)
    // message.destroy()
    // message.loading('导出中，请稍后', 0)
    // request('/clue-web/snm/clue/export', {
    //   method: METHODS.POST,
    //   data: { ...searchValues },
    // }).then((res: any) => {
    //   message.destroy()
    //   fileConfirm()
    // }).catch(() => {
    //   message.destroy()
    // })
  }

  const onImport = (upload: any) => {
    history('/customerManage/clueList/clueImport')
  }
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: { onAdd, exportHandler },
    customRender: {
      treeSelect(props: any) {
        const { key, placeholder }: any = props
        return (
          <TreeSelect
            key={key}
            placeholder={placeholder || '请选择客户来源'}
            allowClear
            treeCheckable
            showSearch
            treeData={sourceChannel}
            // maxTagCount={2}
            maxTagCount="responsive"
            dropdownMatchSelectWidth={false}
            fieldNames={{ label: 'label', value: 'id', children: 'children' }}
            treeNodeLabelProp={'label'}
            style={{ width: "100%" }}
          />
        )
      },
      renderOperate(_, record: Record<string, any>) {
        return (
          record.clueStatus === 'dispatchError' ? <STableActions>
            <SActionBtn onClick={() => onEdit(record)}> 继续分配 </SActionBtn>
          </STableActions> : '-'
        )
      },
      importRender: () => {
        return (
            // <Upload listType="text" customRequest={onImport} itemRender={() => null}>
              <Button type={'primary'} onClick={onImport}>导入</Button>
            // </Upload>
        )
      },
    },
  }

  return (
    <div>
      <SBack title="线索列表"></SBack>
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
    </div>
  )
}